/**
 * @generated SignedSource<<7ec3cbab808f1ecb6ec29bf91fe03514>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpSharedTracking_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useBuyerUrgency_viewer">;
  readonly " $fragmentType": "usePdpSharedTracking_viewer";
};
export type usePdpSharedTracking_viewer$key = {
  readonly " $data"?: usePdpSharedTracking_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpSharedTracking_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpSharedTracking_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useBuyerUrgency_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a42eb1aa14eb2500f64384e0d5be1aad";

export default node;
